import { useCallback, useMemo } from 'react';

import { useUIContext } from 'state/ui';

import {
  buildFormattersMap,
  composeBlockContents,
  interpolatePlaceholders,
} from './locale-smart-block-content-helpers';
import { FormattersMap, TransformSmartBlockContentFn } from './types';

export const useLocaleSmartBlockContent = () => {
  const { formatCurrencyForLocale } = useUIContext();

  const formattersMap = useMemo<FormattersMap>(() => buildFormattersMap(formatCurrencyForLocale), [
    formatCurrencyForLocale,
  ]);

  const transformSmartBlockContent = useCallback<TransformSmartBlockContentFn>(
    ({ blockContent, interpolationSourceObject, placeholderFieldsMap }) => {
      const blocks = blockContent?.localeRaw ?? [];

      const interpolationsMap = interpolatePlaceholders({
        blocks,
        interpolationSourceObject,
        placeholderFieldsMap,
        formattersMap,
      });

      return {
        ...blockContent,
        localeRaw: composeBlockContents({
          blocks,
          interpolationsMap,
        }),
      };
    },
    [formattersMap]
  );

  return {
    transformSmartBlockContent,
  };
};
